import CallerHeader from "./calllogsHeader";
import { Phone, ArrowDownLeft } from "lucide-react";
// import { QueueInfo } from "./QueueInfo";
// import ReactSelect from "src/base-components/ReactSelect";
import Button from "src/base-components/Button";
import { callTypeOptions, outcomeOptions, userTimeZone } from "./constants";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  clearUpdateCall,
  fetchCallLogs,
  queueCalls,
  selectCallDetail,
  selectCustomerInfo,
  selectUpdateCall,
} from "src/stores/calllogs";
import { useEffect, useState } from "react";
import { clearCallLogsToasts } from "src/stores/callLogsToasts/slice";
import Card from "../Card";
import { useAppSelector } from "src/stores";
import { useNavigate } from "react-router-dom";
import { QueueInfo } from "./QueueInfo";

const UserIncomingCard = ({ callerInfo, customerInfo, callDetail }) => {
  const userInfo = customerInfo?.data?.result?.customer;
  const call = callDetail?.data?.call;
  const formatted = call?.event_time && userTimeZone(call?.event_time);
  // const formatDuration = (seconds) => {
  //   const mins = Math.floor(seconds / 60);
  //   const secs = seconds % 60;
  //   return `${mins}:${secs.toString().padStart(2, "0")}`;
  // };

  // Format start time to hh:mm AM/PM
  // const formatTime = (dateTimeString) => {
  //   if (!dateTimeString) return "";
  //   const date = new Date(dateTimeString);
  //   let hours = date.getHours();
  //   const minutes = date.getMinutes().toString().padStart(2, "0");
  //   const ampm = hours >= 12 ? "PM" : "AM";
  //   hours = hours % 12 || 12;
  //   return `${hours}:${minutes} ${ampm}`;
  // };
  return (
    <div className="rounded-xl p-4 border-2">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <div className="rounded-lg relative flex items-center justify-center">
            <Phone className="w-5 h-5  text-blue-600" />

            <ArrowDownLeft className="w-3.5 h-3.5 text-blue-600 absolute -right-1 bottom-[8px] rotate-12" />
          </div>
          <p className="font-medium text-gray-900 text-sm">
            {userInfo?.fullname ?? "New Customer"}
          </p>
        </div>
        <p className="text-[12px] text-[#0A0A0A] border border-gray-200 px-2 py-0.5 rounded-full">
          {callerInfo?.eventType === "call_inbound" ? "Incoming" : "Outgoing"}
        </p>
      </div>
      <div className="flex justify-between items-center pt-2 pb-1">
        <p className="text-[#717182]">{callerInfo?.caller}</p>
        {/* <p className="text-[#717182]">
          Duration:{formatDuration(call?.duration_seconds || 0)}
        </p> */}
        {/* <p className="text-[#717182]">{formatTime(call?.start_time)}</p> */}
        <p className="text-[#717182]">
          {formatted ? formatted?.time12h : "--"}
        </p>
      </div>
      {/* <p className="text-[#717182]">{formatTime(call?.start_time)}</p> */}
    </div>
  );
};
export const DisconnectedCall = ({
  callerInfo,
  onClose,
  callType,
  setCallType,
  callOutcome,
  setCallOutcome,
  updateCallDetail,
}) => {
  const [callNotes, setCallNotes] = useState("");
  const [callNotesError, setCallNotesError] = useState("");
  const [selectedQueryId, setSelectedQueryId] = useState<string | null>(null);
  const customerInfo = useAppSelector(selectCustomerInfo);
  const callDetail = useSelector(selectCallDetail);
  const [skipLoading, setSkipLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, data } = useSelector(selectUpdateCall);
  const [updateLoading, setUpdateLoading] = useState(false);
  const InfoCustomer = customerInfo?.data?.result?.customer;
  const queriesInfo = customerInfo?.data?.result?.queries;

  useEffect(() => {
    const remarks = callDetail?.data?.call?.remarks;
    const getSelectedQuery = callDetail?.data?.call?.query_id;
    setCallNotes(typeof remarks === "string" ? remarks : "");
    setSelectedQueryId(getSelectedQuery || null);
    // Fallback: if no API remarks yet, prefill from local cache saved during query creation
    if ((!remarks || String(remarks).trim() === "") && callerInfo?.sessionId) {
      try {
        const cached = localStorage.getItem(
          `callRemarks_${callerInfo.sessionId}`,
        );
        if (cached && cached.trim().length > 0) {
          setCallNotes(cached);
        }
      } catch (e) {
        // ignore storage errors
      }
    }
  }, [callDetail, callerInfo?.sessionId]);
  console.log("InfoCustomer-dis", InfoCustomer);
  const handleSubmit = async (skip: boolean) => {
    setCallNotesError("");
    if (!hasApiRemarks && !skip && callNotes.trim().length < 10) {
      setCallNotesError("Call Notes & Remarks must be at least 10 characters.");
      return;
    }
    if (skip) {
      setSkipLoading(true);
    } else setUpdateLoading(true);
    const storedNewlyQueryId = localStorage.getItem("newlyQuery");
    const customerId = InfoCustomer?.customer_id ?? "";
    try {
      let payload: any = {
        customer_id: customerId,
        // query_id: selectedQueryId ?? "",
        remarks: callNotes,
        // call_type: callType?.value,
        call_type: "Answered",
        call_outcome: callOutcome?.value,
        queue: skip ? 1 : 0,
        // is_new_query: selectedQueryId === storedNewlyQueryId ? true : null,
      };
      const sessionId = callerInfo?.sessionId;
      updateCallDetail(sessionId, payload);
    } catch (error) {
      console.log("disconnected", error);
    } finally {
      setSkipLoading(false);
      setUpdateLoading(false);
    }
  };

  useEffect(() => {
    if (data?.success === true) {
      onClose();
      dispatch(clearUpdateCall());
      dispatch(clearCallLogsToasts());
      localStorage.removeItem("newlyQuery");
      localStorage.removeItem("selectedQuery");
      // Clear cached remarks for this session once server has been updated
      if (callerInfo?.sessionId) {
        localStorage.removeItem(`callRemarks_${callerInfo.sessionId}`);
      }
      setSkipLoading(false);
      setUpdateLoading(false);
      if (window.location.pathname === "/call-logs") {
        const payload = {
          current_page: 1,
          search: "",
          status: "all",
          type: "all",
          sort_by: "date",
          startDate: null,
          endDate: null,
          // page_size: 10,
          // sort_order: "desc",
          agent_ids: [],
        };
        dispatch(fetchCallLogs(payload));
      } else {
        navigate("/call-logs");
      }
    }
  }, [data?.success]);

  const hasApiRemarks = Boolean(callDetail?.data?.call?.remarks);
  return (
    <>
      <CallerHeader callerInfo={callerInfo} />
      <UserIncomingCard
        callerInfo={callerInfo}
        customerInfo={customerInfo}
        callDetail={callDetail}
      />
      {callerInfo?.callActionInput && callerInfo?.callActionQueue && (
        <QueueInfo callerInfo={callerInfo} />
      )}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (!hasApiRemarks && callNotes.trim().length < 10) {
            setCallNotesError(
              "Call Notes & Remarks must be at least 10 characters.",
            );
            return;
          }
          handleSubmit(false);
        }}
      >
        {queriesInfo &&
          queriesInfo
            ?.filter((query) => query.id === selectedQueryId)
            ?.map((query) => {
              const total =
                (Number(query?.no_of_adults) || 0) +
                (Number(query?.no_of_infants) || 0) +
                (Number(query?.no_of_children) || 0);

              return (
                <Card
                  className="p-3 cursor-pointer transition-all border-gray-200 hover:border-gray-300"
                  key={query.id}
                >
                  <div>
                    <div className="flex justify-between items-center">
                      <h4 className=" text-[#075985] text-sm">
                        {query?.query_no}
                      </h4>
                      <div className="flex items-center justify-between gap-x-2">
                        <p className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                          {query?.status_text}
                        </p>
                        <p className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                          {query?.payment_status}
                        </p>
                      </div>
                    </div>
                    <div className="mt-3">
                      <h4>{InfoCustomer?.fullname}</h4>
                      <div className="flex justify-between items-center mt-1">
                        <p className="text-[10px] text-[#475569]">
                          Customer ID: {InfoCustomer?.customer_id}
                        </p>
                        <p className="text-[10px] text-[#475569]">
                          No. of PAX: {total ?? "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </Card>
              );
            })}

        {/* Call Type */}
        {/* <div className="space-y-3 py-[15px]">
          <label className="block font-medium text-gray-900">
            Call Type <span className="text-red-500">*</span>
          </label>
          <ReactSelect
            options={callTypeOptions}
            value={
              callTypeOptions.find((o) => o.value === callType?.value) || null
            }
            onChange={(selected) => setCallType(selected)}
            placeholder="Support"
          />
        </div> */}

        {/* Call Outcome */}
        {/* <div className="space-y-3 mt-3">
          <label className="block font-medium text-gray-900">
            Call Outcome <span className="text-red-500">*</span>
          </label>
          <ReactSelect
            options={outcomeOptions}
            value={
              outcomeOptions.find((o) => o.value === callOutcome?.value) || null
            }
            onChange={(selected) => setCallOutcome(selected)}
            placeholder="Resolved"
          />
        </div> */}

        {/* Call Notes */}
        <div className="space-y-3 py-[15px]">
          <label className="block font-medium text-gray-900">
            Call Notes & Remarks{" "}
            <span className="text-gray-500">(minimum 10 characters)</span>
          </label>
          <textarea
            placeholder="Provide detailed notes about the call, customer concerns, actions taken, and any follow-up required..."
            className={`w-full h-32 p-3 border rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 ${callNotesError ? "border-red-500" : "border-gray-200"}`}
            value={callNotes}
            required={!hasApiRemarks}
            minLength={!hasApiRemarks ? 10 : undefined}
            onChange={(e) => {
              setCallNotes(e.target.value);
              if (callNotesError && e.target.value.trim().length >= 10) {
                setCallNotesError("");
              }
            }}
          />
          {callNotesError && (
            <p className="text-red-500 text-xs mt-1">{callNotesError}</p>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3">
          <Button
            disabled={updateLoading}
            type="submit"
            variant="primary"
            className="flex-1 bg-[#233580] rounded-xl text-white py-3.5"
          >
            {updateLoading ? "Updating..." : "Update & Close"}
          </Button>
          <Button
            type="button"
            variant="outline-secondary"
            className="flex-1 bg-[#EAEAEA] py-3.5 text-[#2B2B2B] border border-[#C2C2C2] rounded-lg"
            // onClick={() => {
            //   setSkipNow(true);
            //   handleSubmit(true);
            //   // onClose();
            //   // dispatch(clearCallLogsToasts());
            //   // localStorage.removeItem("newlyQuery");
            //   // localStorage.removeItem("selectedQuery");
            // }}
            onClick={() => {
              handleSubmit(true);
            }}
            disabled={skipLoading}
          >
            {skipLoading ? "Skipping..." : "Skip For Now"}
          </Button>
        </div>
      </form>
    </>
  );
};
